import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import GroupChat from "../components/group-chat"

export default function GroupChatPage() {
  const navigate = useNavigate()
  const [referralData, setReferralData] = useState(null)

  // Current user data - in a real app, this would come from authentication
  const currentUser = {
    id: "1",
    name: "Alex Morgan",
    email: "alex@example.com",
    avatar: "/placeholder.svg?height=40&width=40",
    role: "Product Manager",
    company: "TechCorp",
  }

  useEffect(() => {
    // Get referral data from localStorage
    const storedData = localStorage.getItem("referralData")
    if (storedData) {
      setReferralData(JSON.parse(storedData))
    } else {
      // If no data, redirect to create page
      navigate("/dashboard/create-referral")
    }
  }, [navigate])

  const handleBack = () => {
    navigate("/dashboard/referral-success")
  }

  if (!referralData) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  // Initial messages including the introduction message
  const initialMessages = [
    {
      id: "1",
      senderId: currentUser.id,
      text: referralData.message,
      timestamp: new Date(),
      status: "read",
    },
  ]

  return (
    <GroupChat
      currentUser={currentUser}
      participants={[referralData.friend, referralData.contact]}
      onBack={handleBack}
      initialMessages={initialMessages} />
  );
}
